import { createSlice } from "@reduxjs/toolkit";

import {
  fetchHomeworkMasters,
  fetchHomeworkMasterById,
  addHomeworkMaster,
  updateHomeworkMaster,
  deleteHomeworkMaster,
} from "./homeworkMaster.thunk";

const initialState = {
  homeworkMasters: [],
  totalPages: 1,
  currentPage: 1,
  total: 0,
  limit: 10,
  loading: false,
  error: null,
  selectedHomeworkMaster: null,
};

const homeworkMasterSlice = createSlice({
  name: "homeworkMaster",

  initialState,

  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    setSelectedHomeworkMaster: (state, action) => {
      state.selectedHomeworkMaster = action.payload;
    },

    clearSelectedHomeworkMaster: (state) => {
      state.selectedHomeworkMaster = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ============================================================
         FETCH HOMEWORK MASTER LIST
      ============================================================ */

      .addCase(fetchHomeworkMasters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchHomeworkMasters.fulfilled, (state, action) => {
        state.loading = false;
        state.homeworkMasters = action.payload.data;
        state.totalPages = action.payload.meta.total_pages;
        state.total = action.payload.meta.total;
        state.limit = action.payload.meta.limit || 10;
      })

      .addCase(fetchHomeworkMasters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         FETCH SINGLE HOMEWORK MASTER (WITH ROSTER COPIES)
      ============================================================ */

      .addCase(fetchHomeworkMasterById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchHomeworkMasterById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedHomeworkMaster = action.payload;
      })

      .addCase(fetchHomeworkMasterById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         ADD HOMEWORK MASTER
      ============================================================ */

      .addCase(addHomeworkMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(addHomeworkMaster.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(addHomeworkMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         UPDATE HOMEWORK MASTER
      ============================================================ */

      .addCase(updateHomeworkMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(updateHomeworkMaster.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateHomeworkMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         DELETE HOMEWORK MASTER
      ============================================================ */

      .addCase(deleteHomeworkMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(deleteHomeworkMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.homeworkMasters = state.homeworkMasters.filter(
          (homework) => homework.id !== action.payload.id
        );
      })

      .addCase(deleteHomeworkMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setCurrentPage,
  setSelectedHomeworkMaster,
  clearSelectedHomeworkMaster,
} = homeworkMasterSlice.actions;

export default homeworkMasterSlice.reducer;